import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import React, { useCallback } from 'react';
import { getErrorModalType } from '../../bi/scan-failure-bi-mapping';
import { BiCtaNames } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { getScanFailureContent } from '../../utils/get-scan-failure-message';
import { showErrorModal } from './show-error-modal';
export const getFailedAnalyzeSiteModalProps = (t, editorHost, errorMessage, failureReason) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  const reasonContent = failureReason ? getScanFailureContent(t, failureReason) : undefined;
  const contentText = (reasonContent == null ? void 0 : reasonContent.content) ?? errorMessage;
  const titleText = (reasonContent == null ? void 0 : reasonContent.title) ?? t('accessibility-wizard.analyze-full-site.failed-to-analyze-site-modal.title');
  return {
    content: usesClassicModalChrome ? contentText : /*#__PURE__*/React.createElement(Text, null, contentText),
    primaryButtonText: (reasonContent == null ? void 0 : reasonContent.primaryButtonText) ?? t('accessibility-wizard.analyze-full-site.failed-to-analyze-site-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.analyze-full-site.failed-to-analyze-site-modal.secondary-button'),
    skin: 'destructive',
    title: titleText
  };
};
export const useShowFailedAnalyzeSiteModal = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const showFailedAnalyzeSiteModal = useCallback(async _ref => {
    let {
      handleTryAgain,
      handleCancel,
      errorMessage,
      failureReason
    } = _ref;
    const modalType = getErrorModalType(failureReason);
    const reasonContent = failureReason ? getScanFailureContent(t, failureReason) : undefined;
    const contentText = (reasonContent == null ? void 0 : reasonContent.content) ?? errorMessage;
    biLogger.modalView({
      data: contentText,
      modalType
    });
    await showErrorModal({
      ...getFailedAnalyzeSiteModalProps(t, editorHost, errorMessage, failureReason),
      a11yWizardAdapter,
      editorHost,
      primaryButtonOnClick: async () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.TryAgain,
          modalType
        });
        handleTryAgain == null || handleTryAgain();
      },
      secondaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Cancel,
          modalType
        });
        handleCancel == null || handleCancel();
      }
    });
  }, [a11yWizardAdapter, biLogger, editorHost, t]);
  return showFailedAnalyzeSiteModal;
};
//# sourceMappingURL=show-failed-analyze-site-modal.js.map